import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import {
	DONE,
	IN_PROGRESS,
	TODO,
	UNDEFINED,
	statusCategoryForId,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';

const appearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

export const StatusCategoryRead = ({
	statusCategoryId,
	name,
}: {
	statusCategoryId: string;
	name: string;
}) => (
	<Lozenge
		testId="business-fields.ui.status-category.cell.read.lozenge"
		appearance={appearanceMap[statusCategoryForId(statusCategoryId)]}
		isBold={isVisualRefreshEnabled() && fg('visual-refresh_drop_1')}
	>
		{name}
	</Lozenge>
);
